import { deleteRest, get, post, put } from 'utils/rxfetch'
import { buildURL } from 'utils/urls'

export default () => ({
  getGroupSettingsTableData(
    page,
    sortProperty,
    assignedFilter,
    updatedByFilter,
    lastUpdatedFilter,
    search,
    companyId = ''
  ) {
    return get(
      buildURL('/members-api/group-settings-table', {
        page,
        sortProperty,
        assignedFilter,
        updatedByFilter,
        feDateRange: lastUpdatedFilter,
        search,
        companyFilter: companyId,
      })
    )
  },
  cloneGroupSettings(companyId = '', data) {
    return put(`/members-api/group-settings-table?companyFilter=${companyId}`, data)
  },
  deleteGroupSettings(companyId = '', data) {
    return deleteRest(`/members-api/group-settings-table?companyFilter=${companyId}`, data, {
      'Content-Type': 'application/json',
    })
  },
  setGroupSettingsAsDefault(companyId = '', data) {
    return post(`/members-api/group-settings-table?companyFilter=${companyId}`, data)
  },
  getGroupSettingsData(companyId = '', groupSettingsId) {
    return get(
      buildURL('/members-api/group-settings-wizard', {
        groupSettingsId,
        companyFilter: companyId,
      })
    )
  },
  updateGroupSettingsData(companyId = '', data) {
    return post(`/members-api/group-settings-wizard?companyFilter=${companyId}`, data)
  },
  saveInfoForm(companyId = '', data) {
    return put(`/members-api/group-settings-wizard?companyFilter=${companyId}`, data)
  },
  getGroupSettingsCompanies(
    groupSettingsId,
    page,
    sortProperty,
    emailIntegrationFilter,
    groupSettingsFilter,
    assignedFilter,
    search,
    companyId = ''
  ) {
    return get(
      buildURL('/members-api/group-settings-assign', {
        groupSettingsId,
        page,
        sortProperty,
        emailIntegrationFilter,
        groupSettingsFilter,
        assignedFilter,
        search,
        companyFilter: companyId,
      })
    )
  },
  assignGroupSettingsToCompanies(companyId = '', data) {
    return post(`/members-api/group-settings-assign?companyFilter=${companyId}`, data)
  },
})
